import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=39b80946&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import style1 from "./Header.vue?vue&type=style&index=1&id=39b80946&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b80946",
  null
  
)

export default component.exports